<template>
  <i18n-t keypath="from_price">
    <template #price>
      <PriceSpan :price />
    </template>
  </i18n-t>
</template>

<script setup lang="ts">
import type { Price } from '~/types';

defineProps<{
  price: Price;
}>();
</script>